var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3763 8.33366C15.8721 8.33366 17.0846 7.1211 17.0846 5.62533C17.0846 4.12955 15.8721 2.91699 14.3763 2.91699C12.8805 2.91699 11.668 4.12955 11.668 5.62533C11.668 7.1211 12.8805 8.33366 14.3763 8.33366Z",
    stroke: "#575A62",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3763 17.0837C15.8721 17.0837 17.0846 15.8711 17.0846 14.3753C17.0846 12.8796 15.8721 11.667 14.3763 11.667C12.8805 11.667 11.668 12.8796 11.668 14.3753C11.668 15.8711 12.8805 17.0837 14.3763 17.0837Z",
    stroke: "#575A62",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6263 8.33366C7.12207 8.33366 8.33464 7.1211 8.33464 5.62533C8.33464 4.12955 7.12207 2.91699 5.6263 2.91699C4.13053 2.91699 2.91797 4.12955 2.91797 5.62533C2.91797 7.1211 4.13053 8.33366 5.6263 8.33366Z",
    stroke: "#575A62",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6263 17.0837C7.12207 17.0837 8.33464 15.8711 8.33464 14.3753C8.33464 12.8796 7.12207 11.667 5.6263 11.667C4.13053 11.667 2.91797 12.8796 2.91797 14.3753C2.91797 15.8711 4.13053 17.0837 5.6263 17.0837Z",
    stroke: "#575A62",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c1d645d6.svg";
export { ForwardRef as ReactComponent };